import { ActionIcon, CopyButton, Group, Text, Tooltip } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';

export default function CopyableValue({ value, label }: { value: string; label?: string }) {
  return (
    <Group gap={4} wrap="nowrap">
      <Text size="textXs" ff="monospace" truncate="end" style={{ minWidth: 0 }}>
        {label ?? value}
      </Text>
      <CopyButton value={value} timeout={1500}>
        {({ copied, copy }) => (
          <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow>
            <ActionIcon
              size="xs"
              variant="subtle"
              color={copied ? 'teal' : 'gray'}
              onClick={e => {
                e.stopPropagation();
                copy();
              }}
            >
              {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
            </ActionIcon>
          </Tooltip>
        )}
      </CopyButton>
    </Group>
  );
}
